// extracted by mini-css-extract-plugin
export var dividerLine = "_8d-3";
export var itemImage = "_8d-9";
export var lightDivider = "_8d-4";
export var modalContent = "_8d-5";
export var modalContentCompact = "_8d-6";
export var productCard = "_8d-a";
export var productImage = "_8d-b";
export var productImageCompact = "_8d-7";
export var productImagePlaceholder = "_8d-c";
export var productImagePlaceholderCompact = "_8d-8";
export var progressBarBackground = "_8d-1";
export var progressBarContainer = "_8d-0";
export var progressBarFill = "_8d-2";